<template>
  <div class="w-full flex">

    <!-- Preview for form editor -->
    <div v-if="productData == null" class="w-full flex gap-1 items-center">
      <input type="checkbox" class="p-1 w-4 h-4 my-1">
      <div class="w-1/5 flex justify-center">

        <img :src="previewFilePath" style="max-height: 32px;">
      </div>
      <div>
        {{ formField.label }}
      </div>
    </div>

    <!-- Fieldtype -->
    <div v-else class="w-full flex gap-1 items-center">
      <input :disabled="readOnly" :readonly="formField?.readOnly" type="checkbox" class="p-1 w-4 h-4 my-1 " v-model="active" @change="toggle" :class="{ 'bg-inactive' : formField.readOnly, 'shadow-trader-red': productData.customFields[formField.field]?.highlight }">
      <div class="w-1/5 flex justify-center">
        <img :src="previewFilePath" style="max-height: 32px;">
      </div>
      <div>
        {{ formField.label }}
      </div>
    </div>

  </div>
</template>

<script>
import {eventBus} from "@/application/EventBus";
import DSymbolCheckboxOptions from "@/customizations/selgros/Dialogs/DSymbolCheckboxOptions.vue";

export default {
  meta: {
    name: "Symbol Checkbox",
    type: "fieldtype",
    version: "1.0.0",
    hasOptions: true,
    hideLabel: true,
  },
  props: {
    name: "Symbol Checkbox",
    formField: {
      type: Object,
      default: {
        readOnly: false,
      }
    },
    productData: {
      type: Object,
      default: () => {
      }
    },
    onChangeProductFieldValue: {
      type: Function,
      default: () => {
      }
    },
    getFieldValue: {
      type: Function,
      default: () => {
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let parsed = {};
    try {
      parsed = JSON.parse(this.formField.value);
    } catch (e) {
    }

    return {
      uniqueId: parsed?.uniqueId || '',
      previewFilePath: parsed?.previewFilePath || '',
      originalFilePath: parsed?.originalFilePath || '',
    }
  },
  computed: {
    active() {

      const value = this.getFieldValue(this.formField.field, 'string') || '';
      let splitted = value.split(',').map((item) => item.trim()).filter((item) => item !== '');

      return splitted.includes(this.uniqueId.trim());
    }
  },
  methods: {
    toggle() {


      const value = this.getFieldValue(this.formField.field, 'string') || '';
      let splitted = value.split(',').map((item) => item.trim()).filter((item) => item !== '');



      const hasValue = splitted.includes(this.uniqueId.trim());

      if (hasValue) {
        splitted = splitted.filter((item) => item !== this.uniqueId.trim());
      } else {
        splitted.push(this.uniqueId);
      }

      this.onChangeProductFieldValue(this.formField.field, 'string', splitted.join(','));


    }
  },

  showOptions(value, callback) {
    eventBus.openModal(DSymbolCheckboxOptions, {
      title: "Optionen",
      setData: value,
      onApply: callback,
    });
  }
}
</script>


